import { put, call, takeLatest } from "redux-saga/effects";
import { APIClient } from "../../../helpers/api_helper";
import { resetPasswordError, resetPasswordSuccess } from "./actions";
import { RESET_PASSWORD } from "./actionTypes";
const api = new APIClient();

function* resetPassword({ payload: { user } }) {
  const resetUrl = `${process.env.REACT_APP_API_BASE_URL}/admin/reset-password`;
  try {
    const reset = () =>
      api.create(resetUrl, {
        token: user.token,
        password: user.newPassword,
      });
    const response = yield call(reset);

    // The API never returns a token; success is status_code 200, as in the
    // forgot-password saga. Errors (invalid or expired link) are thrown.
    if (response?.status_code === 200) {
      yield put(resetPasswordSuccess());
    } else {
      yield put(resetPasswordError({ data: response }));
    }
  } catch (error) {
    yield put(resetPasswordError({ data: error }));
  }
}

function* resetSaga() {
  yield takeLatest(RESET_PASSWORD, resetPassword);
}

export default resetSaga;
